import dayjs, { Dayjs } from 'dayjs';

export type SchoolIdentifierInput = string | number | null | undefined;

export const clampHolidayDateToPricingYearEnd = (value: Dayjs | null, pricingYearEndDate: string): string => {
    if (!value?.isValid() || !pricingYearEndDate) {
        return '';
    }
    const iso = value.startOf('day').format('YYYY-MM-DD');
    return iso > pricingYearEndDate ? pricingYearEndDate : iso;
};

export const formatSchoolEntityId = (value: SchoolIdentifierInput): string => {
    if (value === null || value === undefined) {
        return '';
    }
    const parsed = String(value).trim();
    if (!parsed) {
        return '';
    }
    if (parsed.startsWith('School-') || parsed.startsWith('school-')) {
        const suffix = parsed.slice(parsed.indexOf('-') + 1);
        return suffix ? `School-${suffix}` : '';
    }
    return `School-${parsed}`;
};

export const normalizeSchoolSelection = (values: readonly SchoolIdentifierInput[] = []): string[] => {
    const seen = new Set<string>();
    const result: string[] = [];
    values.forEach((value) => {
        const formatted = formatSchoolEntityId(value);
        if (formatted && !seen.has(formatted)) {
            seen.add(formatted);
            result.push(formatted);
        }
    });
    return result;
};